import { useCurrentUser } from "@/lib/api/user";
import { useSignedMedia } from "@/lib/hooks/use-signed-media";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";
import { UserAvatar } from "@somethings-ui/web";
import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { UserRecordProfileMenu } from "./user-record-profile-menu";

export function UserRecordSidebarAvatar() {
  const { data: user } = useCurrentUser();
  const { track } = useTrackEvent();
  const [open, setOpen] = useState(false);
  const photo = useSignedMedia(user?.profile_picture_url);
  const name = user?.name || user?.email || "You";

  return (
    <Popover
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        if (next) track(PostHogEvents.SELF_RECORD_CLICKED);
      }}
    >
      <PopoverTrigger asChild>
        <button type="button" aria-label="Open profile menu" className="p-1">
          <UserAvatar name={name} imageUrl={photo.url} size="md" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        className="w-auto border-0 bg-transparent p-0 shadow-none"
      >
        {user ? (
          <UserRecordProfileMenu user={user} onClose={() => setOpen(false)} />
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
